import React, { FC, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { ButtonLoading } from "go-form";
import { ReactComponent as AlertSVG } from "go-core/images/svg/alert.svg";
import { ReactComponent as CalendarSVG } from "go-core/images/svg/calendar.svg";
import FormatResourceStatus from "../../../../../../../../../components/Common/Formatters/FormatResourceStatus/FormatResourceStatus";
import { RenderApplicationLogo } from "../../../../../../../components/RenderApplicationLogo/RenderApplicationLogo";

interface Props {
	familyId: string;
	planName: string;
	planDescription: string;
	editable: boolean;
	status: string;
	date?: string;
	handleResume: () => void;
	toolTipContent?: string | JSX.Element;
}

const UninstalledSubscription: FC<Props> = (props: Props) => {
	const { t } = useTranslation();
	const [loading, setLoading] = useState(false);
	const id = `${props.familyId}_${props.planName}`;

	const onResumeSubscription = () => {
		setLoading(true);
		props.handleResume();
		setLoading(false);
	};

	return (
		<div className={`card subscription-card uninstalled ${!props.editable && "readonly-subscription"}`}>
			<div className={"header"}>
				<RenderApplicationLogo slug={props.familyId} /> <h5>{props.planName}</h5>
				<FormatResourceStatus status={props.status} />
				{props.toolTipContent && (
					<OverlayTrigger
						placement="top"
						overlay={<Tooltip id={`tooltip-${id}`}>{props.toolTipContent}</Tooltip>}
					>
						{({ ref, ...triggerHandler }) => <AlertSVG className={"ms-1"} ref={ref} {...triggerHandler} />}
					</OverlayTrigger>
				)}
				<div className={"subscription-date"}>
					{props.date && (
						<>
							<CalendarSVG className="me-1" />
							<span className="label">{props.date}</span>
						</>
					)}
				</div>
				{props.editable && (
					<>
						<div className={"header-actions"}>
							<ButtonLoading loading={loading} variant={"primary"} onClick={() => onResumeSubscription()}>
								{t("modules.subscription.action.resume_subscription.title")}
							</ButtonLoading>
						</div>
					</>
				)}
			</div>
			<div className={"addon-description"}>{props.planDescription}</div>
		</div>
	);
};

export default UninstalledSubscription;
